function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52234",
  "data-name": "Path 52234",
  d: "M24,24H0V0H24Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52235",
  "data-name": "Path 52235",
  d: "M3.887,14.281h.058c2.833,0,4.722-.162,4.722-2.833,0-2.833,2.833-2.833,2.833-4.722,0-2.112-3.778-1.889-3.778-3.778V2.88",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#7e84a3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52236",
  "data-name": "Path 52236",
  d: "M20,10.5H16.932a2.44,2.44,0,0,1-1.824-4.061l2.031-2.286",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#7e84a3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52237",
  "data-name": "Path 52237",
  d: "M16,14a3,3,0,0,0-3,3,2,2,0,0,0,0,4h5.5a2.494,2.494,0,0,0,.338-4.966A3,3,0,0,0,16,14Z",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#7e84a3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52238",
  "data-name": "Path 52238",
  d: "M20,10.5A8.5,8.5,0,1,0,7.185,17.815",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#7e84a3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgCloudSyncSynchronize6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cloud_Sync_Synchronize.6",
    "data-name": "Cloud, Sync, Synchronize.6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSyncSynchronize6);
export default __webpack_public_path__ + "static/media/Cloud, Sync, Synchronize.6.cafa365c.svg";
export { ForwardRef as ReactComponent };